import React from 'react';
import ReactDOM from 'react-dom/client';

import { createSocket } from '@src/io/index';
import App, { setSocket } from './App';
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux';
import { store } from '@src/state/store';
import { incrementSocketNonce } from './state/slices/slice_app';

import './App.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

if (process.env.NODE_ENV === 'development') {
  // @ts-ignore
  window.address = null;
  // @ts-ignore
  window.setAddress = (address: string) => {
    // @ts-ignore
    window.address = address;
    setSocket(createSocket(address));
    store.dispatch(incrementSocketNonce());
  };
}

root.render(
  <React.StrictMode>
    {/* <GlobalStyle /> */}
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
